import { AdminAttendanceRequestsError } from '@/views/admin-attendance-requests/admin-attendance-requests.error';

export default AdminAttendanceRequestsError;
